import { Route } from 'react-router-dom';
import Dashboard from '../../modules/dashboard/Index';
import React from 'react';
import AuthMiddleware from '../middleware/AuthMiddleware';
import UpdateProfile from '../../modules/auth/UpdateProfile';
import Setting from "../../modules/setting/Setting";

const PrivateRoutes = [
  <Route path="/" element={
    <AuthMiddleware children={<Dashboard />} />
  } />,
  <Route path="/update-profile" element={
    <AuthMiddleware children={<UpdateProfile />} />
  } />,
  <Route path="/settings" element={
    <AuthMiddleware children={<Setting />} />
  } />,
];

export default PrivateRoutes;
